import React, { FC } from 'react';

import styles from './styles.module.css';

type TypeaheadResultProps = {
  primaryResult: string;
  secondaryResult?: string;
};

export const TypeaheadResult: FC<TypeaheadResultProps> = ({
  primaryResult,
  secondaryResult,
}) => {
  return (
    <>
      <div className={styles.primaryResult}>{primaryResult}</div>
      {secondaryResult && (
        <div className={styles.secondaryResult}>{secondaryResult}</div>
      )}
    </>
  );
};
